export default __webpack_public_path__ + "static/play-agent1-bop-english-a97d9bc15fc1cec096fd3e59c368bbef.png";